import { FormikSharedConfig } from 'formik';

const formikGlobalConfig: FormikSharedConfig = {
  validateOnChange: false,
};

export default formikGlobalConfig;
